import React from 'react';
import './ProductOutletBanner.scss';

function ProductOutletBanner() {
  return (
    <div className="plp__outlet">
      <div className="plp__outlet-bg">
        <div className="plp__outlet-container">
          <div className="plp__outlet-title">
            <h1>OUTLET Products</h1>
            <p>
              Big Deals on Big Style
              <br />
              Shop from our Outlet section Now !
            </p>
          </div>
        </div>
      </div>
      <p className="plp__outlet-text">
        Big Deals on Big Style
        <br />
        Shop from our Outlet section Now !
      </p>
    </div>
  );
}

export default ProductOutletBanner;
